import { axios, Response } from '../index'
import { FilesAndFolders } from './get-folder-files-and-subfolders'

const getFolderFilesGroup = (
  groupId: string,
  folderId: string | null
): Response<FilesAndFolders> => {
  return axios.get(`/v1/group/${groupId}/folders/${folderId}`)
}

export default getFolderFilesGroup
